module.exports = __webpack_public_path__ + "img/icon.84a31202.png";